import {useSelector} from 'react-redux'
import {selectBuildingsByActiveOrganization} from '../../../reducers/selectors'
import SortableTable, {ColumnConfig} from '../../SortableTable'
import HighlightText from '../../HighlightText'
import EmptyStateIconAndMessage from '../../EmptyStateIconAndMessage'
import RXRIcon from '../../RXRIcon'
import PropTypes from 'prop-types'
import React from 'react'

const ACTIVE_COPY = 'Active'
const INACTIVE_COPY = 'Off'

function ListChatSettingsTable(props) {
  const buildingsInOrg = useSelector(selectBuildingsByActiveOrganization)

  const hasFiltersApplied = !!props.filterTerm

  const lowerFilter = props.filterTerm.toLowerCase()
  const dataToRender = buildingsInOrg.filter(item => {
    if (!props.filterTerm) {
      return true
    }
    return item.displayName.toLowerCase().includes(lowerFilter)
  })

  const columns = [
    new ColumnConfig({
      title: 'Asset Name',
      renderPrimitive: item => item.displayName,
      render: (r, col) => {
        return (
          <div>
            <HighlightText search={props.filterTerm}>{col.renderPrimitive(r)}</HighlightText>
          </div>
        )
      },
      comparator: ColumnConfig.simpleComparatorGenerator('buildingName'),
    }),
    new ColumnConfig({
      title: 'Chat schedule',
      renderPrimitive: item => getCopyFromBoolean(item.deskHoursEnabled),
      render: (r, col) => {
        return (
          <div>
            <HighlightText search={props.filterTerm}>{col.renderPrimitive(r)}</HighlightText>
          </div>
        )
      },
      comparator: ColumnConfig.simpleComparatorGenerator('deskHoursEnabled'),
    }),
  ]

  if (dataToRender.length > 0) {
    return <SortableTable getKey={d => d.id} data={dataToRender} columns={columns} onClickRow={r => props.onClickBuilding(r.id)} />
  }

  // Show appropriate empty state
  if (hasFiltersApplied && buildingsInOrg.length > 0) {
    return <EmptyStateIconAndMessage message={'No buildings match the selected filter(s)'} icon={RXRIcon.MESSAGES} />
  }

  return <EmptyStateIconAndMessage message={'No buildings matching search'} icon={RXRIcon.MESSAGES} />
}
function getCopyFromBoolean(b) {
  return b ? ACTIVE_COPY : INACTIVE_COPY
}

ListChatSettingsTable.propTypes = {
  filterTerm: PropTypes.string,
  onClickBuilding: PropTypes.func,
}

export default ListChatSettingsTable
